<template>
  <div class="right-chart-1">
    <div class="cc-header flex justify-around item-center p-2">
      <dv-decoration-1 style="width: 100px; height: 20px" />
      <div class="text-xl font-bold">实时公告通知</div>
      <dv-decoration-1 style="width: 100px; height: 20px" />
    </div>
    <div class="webtake">
      根据《大渡口区医养结合全覆盖建设工作方案》的文件精神，积极探索医养结合全覆盖服务模式，利用先进的医疗科技能力，赋能医养结合落地服务，
      将专业和服务有机结合，全力协助区政府和区民政有序达成大渡口区医养结合全覆盖总体目标。
    </div>
  </div>
</template>

<script>
export default {
  name: "RightChart1",
  data() {
    return {
      config: {
        data: [
          {
            name: "收费系统",
            value: 25,
          },
          {
            name: "通信系统",
            value: 66,
          },
          {
            name: "监控系统",
            value: 123,
          },
          {
            name: "供配电系统",
            value: 72,
          },
          {
            name: "其他",
            value: 99,
          },
        ],
        unit: "件",
      },
    };
  },
};
</script>

<style lang="less">
.right-chart-1 {
  width: 100%;
  // height: 100%;
  height: 160px;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  padding: 20px;
  .rc1-header {
    font-size: 24px;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
  }

  .rc1-chart-container {
    flex: 1;
    display: flex;
  }

  .left {
    width: 30%;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .number {
      font-size: 34px;
      color: #096dd9;
      font-weight: bold;
      margin-bottom: 30px;
    }
  }

  .right {
    flex: 1;
    padding-bottom: 20px;
    padding-right: 20px;
    box-sizing: border-box;
  }
  .webtake {
    padding: 0px 10px 0px 10px;
    font-size: 15px;
  }
}
</style>
